const styles = {
  containerHead: {
    margin: 0,
    width: '100%',
    display: 'flex',
    justifyContent: { xs: 'center', sm: 'space-between' },
    alignItems: 'center',
    '& h1': {
      width: { xs: '100%', sm: 'auto' },
      order: { xs: 2, sm: -1 },
    },
  },
  container: {
    display: 'flex',
    justifyContent: { xs: 'center', sm: 'space-between', md: 'flex-start' },
    marginBottom: '2em',
    '& span': {
      width: '100%',
      textAlign: 'center',
      marginTop: 4,
    },
  },
  conatainerFirst: {
    '& .MuiGrid2-root:nth-of-type(1)': {
      '& .MuiCardContent-root:nth-of-type(2)': {
        px: { xs: 0, md: 2 },
        py: 2,
      },
    },
  },

  banner: {
    '& .MuiContainer-maxWidthLg': {
      pt: { xs: 0, lg: 8 },
    },
  },

  mostRecent: {
    boxShadow: 'none',
    width: { xs: '100%', sm: 272, lg: 370 },
    height: 450,
    border: 'none',
    '& .MuiBox-root': {
      width: '100%',
      height: '60%',
      '& img': {
        objectFit: 'cover!important',
        borderRadius: 1,
      },
    },
    '& .MuiCardContent-root': {
      p: 0,
      py: 2,
      '.MuiTypography-body1': {
        WebkitLineClamp: '2',
      },
    },
  },

  otherNotes: {
    width: { xs: '100%', sm: 272, lg: 270 },
  },

  containerPaginator: {
    justifyContent: 'center',
    mt: 2,
    mb: 5,
  },

  itemContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: { xs: 'center', sm: 'space-between' },
    width: '100%',
  },
  shareIn: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: { xs: 'flex-left', sm: 'center' },
    '& p': { mr: 2 },
    button: {
      mr: 2, display: 'flex',
    },
  },
  toShare: { display: 'flex', mt: { xs: 1, sm: 0 } },
  imgContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    position: 'relative',
    '&.MuiBox-root': {
      width: '100%',
      height: 339,
      '& img': {
        objectFit: 'cover!important',
      },
    },
  },
  data: {
    '& p': {
      fontWeight: ' 500',
      fontSize: '14px',
      lineHeight: '15px',
      color: 'text.secondaryDark',
    },
    figure: {
      p: 0,
      m: 0,
      textAlign: 'center',
    },
    img: {
      width: { xs: '100%', md: 'auto' },
      maxWidth: '100%',
      height: 'auto',
      objectFit: 'contain',
    },
    iframe: { width: { xs: '100%', md: '50%' } },
  },

  googleForm: {
    iframe: {
      width: '100%!important',
    },
  },
  pagination: {
    '& .MuiPaginationItem-previousNext': {
      backgroundColor: 'background.grey600',
      color: 'primary.main',
    },
    '& .MuiPaginationItem-page': {
      background: 'none',
      fontWeight: ' 400',
      fontSize: '12px',
      lineHeight: '14px',
      color: 'text.grey800',
      ':hover': {
        background: 'none',
      },
    },
    '& .Mui-selected': {
      color: 'text.primaryDark',
    },
  },

  socialNetworks: {
    p: 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'third.main',
    '& .MuiTypography-body1 ': {
      color: 'text.white',
      width: { xs: '100%', md: '40%' },
      textAlign: 'center',
    },
  },
  socialNetworksItems: {
    display: 'flex',
    alignItems: 'center',
    a: { mx: { xs: 0.6, md: 1 } },
  },
  relatedPosts: { '& .MuiGrid2-container': { p: 0 } },
}

export default styles
